import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectConditionSecurityManagementDevice
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/MezzoConditions/SelectConditionSecurityManagementDevice/SelectConditionSecurityManagementDevice'
import SelectConditionSecurityManagementDeviceIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/MezzoConditions/SelectConditionSecurityManagementDevice/SelectConditionSecurityManagementDevice'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView
  ? withStyles(SelectConditionSecurityManagementDeviceIOS) : withStyles(SelectConditionSecurityManagementDevice)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isNCentral } = state.unit
  const {
    sceneReviewConditionTypes,
  } = state.scenes.currentSceneCreating
  return {
    isNCentral,
    sceneReviewConditionTypes,
    isMobile,
    path,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectConditionSecurityManagementDeviceEnhanced = enhance

export default withRouter(SelectConditionSecurityManagementDeviceEnhanced)
